import {
  BOOKAPPOINTMENTREQ,
  BOOKAPPOINTMENTSUCCESS,
  BOOKAPPOINTMENTFAILED,
  SET_SELECTED_APPOINTMENT,
  CLEAR_SELECTED_APPOINTMENT,
} from "../actions/appointmentActions";

const initialState = {
  loading: false,
  appointmentData: null,
  error: null,
  selectedAppt:null
};

export const appointmentReducer = (state = initialState, action) => {
  switch (action.type) {
    case BOOKAPPOINTMENTREQ:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case BOOKAPPOINTMENTSUCCESS:
      return {
        ...state,
        loading: false,
        appointmentData: action.payload,
        error: null,
      };

    case BOOKAPPOINTMENTFAILED:
      return {
        ...state,
        loading: false,
        error: action.error,
      };

    case SET_SELECTED_APPOINTMENT:
      return { ...state, selectedAppt: action.payload };

    case CLEAR_SELECTED_APPOINTMENT:
      return { ...state, selectedAppt: action.payload };

    default:
      return state;
  }
};

export default appointmentReducer;
